import { onMounted, ref, h, inject } from 'vue';
import KKCustomUI from 'kk_custom_ui';
import { pushUrl } from '@/business/chat/custom-message-util';
import { CustomMessageClickAction } from '_c/typings/model/chat/text-node';
import { generateRealImage } from '_c/util/image';
import EventBus from '_c/util/event-bus';
import { ChatPageEvents, ChatPageEventType } from '_c/typings/event/global';
import { IMsg } from '_c/typings/model/im';

const MSG_LAYOUT_ERR_TIP = '消息格式不支持';
const CUSTOM_MSG_TEMPLATE_READY = 'CustomMsgTemplateReady';

function getImageInfo(url: string) {
  const MAX_IMAGE_WIDTH = 230;
  const MAX_IMAGE_HEIGHT = 230 * 1.414;
  const MIN_IMAGE_WIDTH = 230 / 3;
  const MIN_IMAGE_HEIGHT = 230 / 3;
  // 没有相关信息，全部填空值
  return generateRealImage({
    type: 0,
    width: 0,
    height: 0,
    url,
    size: 0,
    md5sum: '0',
  }, {
    maxImageHeight: MAX_IMAGE_HEIGHT,
    maxImageWidth: MAX_IMAGE_WIDTH,
    minImageHeight: MIN_IMAGE_HEIGHT,
    minImageWidth: MIN_IMAGE_WIDTH,
  });
}


export function useRenderV2(content: Record<string, unknown>) {
  const el = ref<HTMLInputElement | null>(null);

  const chatPageEventBus = inject<EventBus<ChatPageEvents> | null>('chatPageEventBus', null);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const messageData = inject<IMsg>('messageData')!;


  function handleEvent(params: Record<string, unknown>) {
    switch (params.action) {
      case 'preview':
        chatPageEventBus?.emit(ChatPageEventType.customUiPictureClick, {
          messageInfo: messageData,
          imageInfo: getImageInfo(params.url as string),
        });
        return;
      case 'webhook':
        pushUrl({
          action: CustomMessageClickAction.webhook,
          ...params,
        });
        break;
      case 'scheme':
        pushUrl({
          action: CustomMessageClickAction.scheme,
          ...params,
        });
        break;
      default:
        throw Error(`不支持的Action:${params.action}`);
    }
  }

  const kkCustomUI = new KKCustomUI({
    eventHandler: handleEvent,
  });

  onMounted(() => {
    if (el.value) {
      try {
        /// 如果有templateId就是走模板分离的
        if (content?.templateId) {
          if (window.customMsgTemplate) {
            layoutCustom();
          } else {
            /// 未加载就等待事件再进行渲染
            window.addEventListener(CUSTOM_MSG_TEMPLATE_READY, layoutCustom);
          }
        } else {
          kkCustomUI.build(el.value, content);
        }
      } catch (error) {
        el.value.innerText = MSG_LAYOUT_ERR_TIP;
      }
    }
  });

  function layoutCustom() {
    try {
      if (el.value) {
        const templateId = content.templateId as string;
        const data = content.data as Record<string, unknown>;
        // 使用模板的temp进行解析，不更改原有模板
        const customMsgTemplate = window.customMsgTemplate as Record<string, unknown>;
        const template = JSON.parse(JSON.stringify(customMsgTemplate[templateId] as Record<string, unknown>));
        kkCustomUI.buildFromTemplate(el.value, template, data);
        window.removeEventListener(CUSTOM_MSG_TEMPLATE_READY, layoutCustom);
      }
    } catch (error) {
      if (el.value) {
        el.value.innerText = MSG_LAYOUT_ERR_TIP;
      }
    }
  }

  return function () {
    return h('div', {
      style: { 'max-width': '380px' },
      ref: el,
    }, ['']);
  };
}

